'use client';

import React, { useState } from 'react';
import { AnimatedTitle } from '../../animated-title';

import type { LandscapeProcess } from '@/types';
import { MoveRight } from 'lucide-react';
import { lexicalStateToHtml } from '@/lib/utils/lexical-to-html';
import { getMediaData, getFilmData, resizedImageProps } from '@/lib/utils/media.utils';

interface LandscapeProcessProps {
  layout: LandscapeProcess;
}

export const Landscape_Process: React.FC<LandscapeProcessProps> = ({ layout }) => {
  return (
    <section className="w-full">
      <div className="p-[15px] rounded-md bg-white mb-[12px] flex flex-col justify-between relative pt-8">
        {layout.title ? (
          <div className="static lg:absolute top-[15px] left-[15px] text-gray-500">
            <AnimatedTitle marginClass="mb-0">{layout.title}</AnimatedTitle>
          </div>
        ) : (
          ''
        )}
        {layout.titleRightTop ? (
          <div className="static lg:absolute top-[15px] right-[15px] text-gray-500">
            <AnimatedTitle marginClass="mb-0">{layout.titleRightTop}</AnimatedTitle>
          </div>
        ) : (
          ''
        )}

        {/* Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 mt-1 lg:mt-6">

          <div className="content-section rounded-md flex pr-0 lg:pr-16 order-2 lg:order-1">
            <div className="w-full">
              {layout.items.map((item, index) => {
                const [isOpen, setIsOpen] = useState(index === 0); // İlk öğe açık gelecek

                return (
                  <div key={index} className="bg-[#F4F4F4] rounded-md text-gray-500 mt-6 font-mono text-[10px]">
                    <div
                      className="bg-[#E6E6E6] rounded-md px-5 py-3 flex justify-between items-center uppercase cursor-pointer"
                      onClick={() => setIsOpen(!isOpen)}
                    >
                      <span>{item.title}</span>
                      <MoveRight className={`text-gray-500 w-4 transition-transform ${isOpen ? 'rotate-90' : ''}`} />
                    </div>
                    {isOpen && (
                      <div
                        className="p-5 contentstd"
                        dangerouslySetInnerHTML={{
                          __html: lexicalStateToHtml(item.content),
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          <div className="mt-1 lg:mt-6 relative text-gray-500 order-1 lg:order-2">
            {layout.titleDisplay ? (
              <div className="static lg:absolute lg:top-[-64px] lg:left-0">
                <AnimatedTitle marginClass="mb-0">[ {layout.titleDisplay} ]</AnimatedTitle>
              </div>
            ) : (
              ''
            )}

            {layout.items[0]?.images?.length > 0 ? (
              // İlk öğenin ilk resmi varsa göster
              <img
                {...resizedImageProps(
                  typeof layout.items[0].images[0] === 'number'
                    ? `/api/media/${layout.items[0].images[0]}`
                    : getMediaData(layout.items[0].images[0]).url,
                  1080,
                  '(max-width: 768px) 100vw, 50vw',
                )}
                alt={''}
                className="w-full h-auto rounded-md"
              />
            ) : layout.items[0]?.video ? (
              // İlk öğenin videosu varsa göster
              <video
                src={
                  typeof layout.items[0].video === 'number'
                    ? `/api/media/${layout.items[0].video}`
                    : getFilmData(layout.items[0].video).url
                }
                controls
                className="w-full h-auto rounded-md"
              />
            ) : (
              // Hiçbiri yoksa "görsel" yazısını göster
              'Display'
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
